import React from "react";
import { Button, TextField, Form } from "@vitalsource/vstui";
import { Translation, t } from "../../../core/translate";
import { GrayBlock } from "../styles";
import Link from "../../../components/link";
import { isValidPassword } from "../utils";
import { FormAlert } from "../form-alert";

const signin = () => (
  <div>
    <FormAlert level="warning" key="password-reset">
      <Translation id="forgot-password.password-reset">
        Password Reset
      </Translation>
    </FormAlert>
    <GrayBlock>
      <p>
        <Translation id="forgot-password.password-reset-text">
          Your password has been successfully reset!
        </Translation>
      </p>
      <Link href="/user/signin">{t("signin.signin-button", "Sign In")}</Link>
    </GrayBlock>
  </div>
);

export default class PasswordResetForm extends React.PureComponent {
  render() {
    const { updateForgottenPassword, passwordUpdated } = this.props;
    if (!passwordUpdated) {
      return (
        <Form
          onSubmit={updateForgottenPassword}
          id="reset-password-form"
          method="post"
        >
          <TextField
            required
            id="password-field"
            type="password"
            name="password"
            label={t("base.password", "Password")}
            nativeFormControlRef={x => (this.password = x)}
            helperText={t(
              "registration.valid-password",
              "Password Helper Text"
            )}
            fullWidth
            size="large"
            validate={() => {
              if (!isValidPassword(this.password.value)) {
                return t("registration.valid-password", "Password Helper Text");
              }
            }}
            data-test="password"
          />
          <TextField
            required
            id="confirm-password-field"
            type="password"
            name="confirm-password"
            label={t("base.confirm-password", "Confirm Password")}
            nativeFormControlRef={x => (this.passwordConfirmation = x)}
            fullWidth
            size="large"
            validate={() => {
              if (this.passwordConfirmation.value !== this.password.value) {
                return t("registration.pwd-no-match", "Passwords must match");
              }
            }}
            data-test="confirm-password"
          />
          <Button
            id="submit-btn"
            fullWidth
            size="large"
            data-test="password-submit"
          >
            {t("base.submit")}
          </Button>
        </Form>
      );
    } else {
      return signin();
    }
  }
}
